const PermissionsList = {
    view_indent: 1,
    all_indent: 2,
    create_indent: 3,
    update_indent: 4,
    delete_indent: 5,
    reindent: 6,
    track_indent: 7,
    cancel_indent: 8,
    optimized_indent: 9,
    indent_add_docks: 10,
    indent_at_load_point: 11,
    indent_inspection: 12,
    indent_truck_assign: 13,
    indent_truck_in: 14,
    indent_truck_out: 15,
    indent_start_load: 16,
    indent_end_load: 17,
    indent_mark_deliver: 18,
    indent_add_materials: 19,
    indent_generate_eway_bill: 20,
    indent_add_lr: 21,
    indent_update_pod: 22,
    indent_view_indented: 23,
    indent_view_truck_change_requested: 24,
    indent_view_rejected: 25,
    indent_view_accepted: 26,
    indent_view_assigned: 27,
    indent_view_arrived: 28,
    indent_view_dispatched: 29,
    indent_view_delivered: 30,
    indent_view_cancelled: 31,
    indent_view_truck_rejected: 32,
    indent_view_loading_started: 33,
    indent_view_loading_ended: 34,
    view_consignee: 35,
    update_consignee: 36,
    delete_consignee: 37,
    create_consignee: 38,
    import_consignee: 39,
    export_consignee: 40,
    view_bucc: 41,
    update_bucc: 42,
    delete_bucc: 43,
    create_bucc: 44,
    import_bucc: 45,
    export_bucc: 46,
    view_contract: 47,
    update_contract: 48,
    delete_contract: 49,
    create_contract: 50,
    import_contract: 51,
    export_contract: 52,
    view_detention: 53,
    create_detention: 54,
    update_detention: 55,
    delete_detention: 56,
    import_detention: 57,
    export_detention: 58,
    view_material: 59,
    create_material: 60,
    update_material: 61,
    delete_material: 62,
    import_material: 63,
    export_material: 64,
    view_rate_matrix: 65,
    create_rate_matrix: 66,
    update_rate_matrix: 67,
    delete_rate_matrix: 68,
    import_rate_matrix: 69,
    export_rate_matrix: 70,
    all_depot: 71,
    view_depot: 72,
    update_depot: 73,
    delete_depot: 74,
    create_depot: 75,
    import_depot: 76,
    export_depot: 77,
    all_gate: 78,
    view_gate: 79,
    create_gate: 80,
    update_gate: 81,
    delete_gate: 82,
    import_gate: 83,
    export_gate: 84,
    all_dock: 85,
    view_dock: 86,
    create_dock: 87,
    update_dock: 88,
    delete_dock: 89,
    import_dock: 90,
    export_dock: 91,
    view_role: 92,
    create_role: 93,
    update_role: 94,
    delete_role: 95,
    view_user: 96,
    create_user: 97,
    update_user: 98,
    delete_user: 99,
    import_user: 100,
    export_user: 101,
    view_transporter: 102,
    create_transporter: 103,
    update_transporter: 104,
    delete_transporter: 105,
    import_transporter: 106,
    export_transporter: 107,
    view_transporter_vehicle: 108,
    view_invoice: 109,
    update_invoice: 110,
    delete_invoice: 111,
    accept_invoice: 112,
    reject_invoice: 113,
    verify_invoice: 114,
    document_invoice: 115,
    view_dashboard: 116,
    view_reports: 117,
    view_settings: 118,
    update_settings: 119,
    librarian_accept_invoice: 120,
    librarian_reject_invoice: 121,
    accounts_accept_invoice: 122,
    accounts_reject_invoice: 123,
    optima_upload: 124,
    optima_view_indent: 125,
    optima_create_indent: 126,
    optima_edit_indent: 127,
    optima_settings: 128,
    invoice_generate_voucher: 129,
    voucher_view: 130,
    miro_download: 131,
    invoice_reapprove: 132,
    view_vehicle: 133,
    create_vehicle: 134,
    update_vehicle: 135,
    delete_vehicle: 136,
    import_vehicle: 137,
    export_vehicle: 138,
    add_freight_charge: 139,
    optima_material: 140,
    view_transit_management: 141,
    // commented permissions to be uncommented when respective functionalities
    // implemented in transit management
    // create_transit_management: 142,
    // update_transit_management: 143,
    import_transit_management: 144,
    export_transit_management: 145,
    view_sla_settings: 146,
    update_sla_settings: 147,
    view_material_header_settings: 148,
    update_material_header_settings: 149,
    approve_pod: 150,
    indent_view_reported: 151,
    indent_view_assign_due: 152,
    indent_view_accept_due: 153,
    indent_view_arrived_due: 154,
    indent_view_delivery_pending: 155,
    invoice_export: 156,
    payment_upload: 157,
    rfq_update: 158,
    indent_report_at_depot: 159,
    override_reindent: 160,
    view_wallet: 161,
    import_loading: 162,
    import_sla: 163,
    view_sla: 164,
    view_loading: 165,
    indent_add_materials_invoice: 166,
    view_contracttsd: 167,
    // update_contracttsd: 168,
    // create_contracttsd: 169,
    import_contracttsd: 170,
    export_contracttsd: 171,
    update_client_settings: 172,
    view_client_settings: 173,
    update_depot_settings: 174,
    view_depot_settings: 175,
    exceptions: 176,
    master_exceptions_download: 177,
    transaction_exceptions_download: 178,
    change_truck_type: 179,
    export_extra_drop_off_charge: 180,
    import_extra_drop_off_charge: 181,
    view_extra_drop_off_charge: 182,
    view_vehicle_utilization: 183,
    request_vehicle_utilization: 184,
    update_vehicle_utilization: 185,
    approve_vehicle_utilization: 186,
    view_bfr: 187,
    import_bfr: 188,
    export_bfr: 189,
    payments_v2: 190,
    create_contract_indent: 191,
    update_contract_indent: 192,
    view_contract_indent: 193,
    create_open_indent: 194,
    update_open_indent: 195,
    view_open_indent: 196,
    create_no_freight_indent: 197,
    update_no_freight_indent: 198,
    view_no_freight_indent: 199,
    delete_lr_attachment: 200,
    override_cancel_indent: 201,
    optima_summary: 202,
    indent_consignee_gate_update: 203,
    optima_indent_split: 204,
    create_market_indent: 205,
    update_market_indent: 206,
    view_market_indent: 207,
    view_holiday_settings: 208,
    view_bids_settings: 209,
    optima_auto_run: 210,
    view_vendor_depot: 211,
    view_mdmlocation: 212,
    update_mdmlocation: 213,
    delete_mdmlocation: 214,
    create_mdmlocation: 215,
    import_mdmlocation: 216,
    export_mdmlocation: 217,
    optima_indent_combine: 218,
    hide_inbound_indents_selection: 219,
    hide_movement_type_filter: 220,
    hide_indent_upload: 221,
    hide_document_view: 222,
    hide_lr_details: 223,
    hide_rfq_quotes: 224,
    hide_enable_track: 225,
    trigger_epod: 226,
    view_shortage_damage_settings: 227,
    hide_lr_update_post_truck_out: 228, // specific for OEL
    view_materialcategory: 229,
    create_materialcategory: 230,
    update_materialcategory: 231,
    import_materialcategory: 232,
    export_materialcategory: 233,
    view_performance_dashboard: 234,
    view_driver: 235,
    view_mdm_blacklist_vehicle: 236,
    blacklist_vehicle_driver: 237,
    unblacklist_vehicle_driver: 238,
    indent_export_materials: 239,
    export_blacklist_vehicle: 240,
    export_driver: 241,
    view_dedicatedtruck: 242,
    create_dedicatedtruck: 243,
    update_dedicatedtruck: 244,
    import_dedicatedtruck: 245,
    export_dedicatedtruck: 246,
    grn_bulk_upload: 247,
    view_revenue_dashboard: 248,
    view_insights_dashboard: 249,
    view_value_discovery_dashboard: 250,
    view_live_dashboard: 251,
    update_expected_delivery_at_after_dispatch: 252, // For open indent alone
    grn_approval: 253,
    update_consignment_number: 254,
    base_freight_view: 255,
    export_sla: 256,
    export_loading: 257,
    inbound_mark_deliver: 258,
    view_operations_dashboard: 259,
    view_value_discovery_1_dashboard: 260,
    view_value_discovery_2_dashboard: 261,
    import_purchase_order: 262,
    view_purchase_order: 263,
    export_purchase_order: 264,
    view_container: 265,
    import_container: 266,
    create_container: 267,
    update_container: 268,
    view_freight_forwarder: 269,
    create_freightforwarder: 270,
    update_freightforwarder: 271,
    create_exim: 272,
    view_exim: 273,
    update_exim: 274,
    view_incoterm: 275,
    cancel_master_indent_export: 276,
    view_port: 277,
    import_port: 278,
    create_port: 279,
    update_port: 280,
    view_cha: 281,
    update_container_number: 282,
    indent_view_container_picked: 283,
    import_cha: 284,
    create_cha: 285,
    update_cha: 286,
    retry_modified_picklist: 287,
    clone_indent: 288,
    draft_indent: 289,
    edit_sales_order: 290,
    vendor_material_upload: 291,
    view_transporter_performance_dashboard: 292,
    view_depot_performance_dashboard: 293,
    view_rate_calculator: 294,
    create_direct_delivery_indent: 295,
    view_open_indents_settings: 296,
    update_open_indents_settings: 297,
    retry_freight_provision: 298,
    create_direct_dispatch_indent: 500,
    is_vehicle_type_editable: 501,
    epod_rejection: 502,
    view_chat_settings: 999,
    update_chat_settings: 998,
  
    // Pay V2 Charges level permissions
    additional_point_charges: 299,
    arrival_charge: 300,
    carton_damage_charge: 301,
    contract_charge: 302,
    damage_charge: 303,
    extra_charges: 304,
    leakage_charge: 305,
    loading_charge: 306,
    loading_detention_charge: 307,
    lr_charge: 308,
    oda_charge: 309,
    fixed_charge: 310,
    shortage_charge: 311,
    transit_charge: 312,
    unloading_charge: 313,
    unloading_detention_charge: 314,
    wallet_penalty_charge: 315,
    // Pay V2 Charges level permissions
    retry_freight_invoice_posting: 316,
    view_detention_settings: 317,
    update_detention_settings: 318,
    update_weigh_bridge: 319,
    indent_empty_container_return: 320,
    edit_vessel_date: 321,
    view_business_dashboard: 322,
    trigger_pull_picklist: 323,
    indent_custom_field: 324,
  
    ship_ready: 325,
    view_ship_ready: 336,
    shipped: 337,
    view_shipped: 338,
    view_pack: 339,
    view_document_settings: 340,
    view_packing_performance_dashboard: 341,
  
    view_carton: 342,
    create_carton: 343,
    update_carton: 344,
  
    view_carrier: 345,
    create_carrier: 346,
    update_carrier: 347,
  
    view_shipmethod: 348,
    create_shipmethod: 349,
    update_shipmethod: 350,
  
    edit_truckinout_timestamp: 354,
    hide_voucher_action: 355,
  
    create_delivery_numbers: 356,
    view_delivery_numbers: 357,
    cancel_invoice: 358,
    view_depot_level_cost_flow_dashboard: 359,
    view_transit_dashboard: 360,
    freight_provision_report: 361,
    generate_manifest: 362,
    override_freight_charge: 363,
    view_control_tower: 364,
    view_support_widget: 365,
    special_truck_in: 366,
    special_truck_out: 367,
  
    // invoice permissions movement wise
    approve_invoice_primary: 368,
    return_invoice_primary: 369,
    check_invoice_primary: 370,
    accounts_reject_invoice_primary: 371,
    approve_invoice_secondary: 372,
    return_invoice_secondary: 373,
    check_invoice_secondary: 374,
    accounts_reject_invoice_secondary: 375,
    approve_invoice_vendor: 376,
    return_invoice_vendor: 377,
    check_invoice_vendor: 378,
    accounts_reject_invoice_vendor: 379,
    approve_invoice_return: 380,
    return_invoice_return: 381,
    check_invoice_return: 382,
    accounts_reject_invoice_return: 383,
  
    view_procure: 384,
  
    // WORFLOW PERMISSIONS
  
    /**
     * Optima movement type permissions
     */
    optima_movement_type_Primary: 385,
    optima_movement_type_Secondary: 386,
    optima_movement_type_Vendor: 387,
    optima_movement_type_Return: 388,
  
  
    view_packing_manual_tracking_number: 389,
    view_freight_charges_threshold: 390,
    update_freight_charges_threshold: 391,
    retry_all_documents: 392,
  
    // Masterdata Rejections View Rates Permissions
    view_rejection_rate_details: 393,
    update_master_indent: 394,
  
    view_marauders: 395,
    wallet_approve_at_generated: 396,
    view_wallet_settings: 397,
    indent_gate_pass: 398,
  
    // view assign vehicle
    indent_truck_view: 399,
    indent_view_docks: 400,
    view_discount_settings: 401,
    update_discount_settings: 402,
  
    edit_timestamps: 403,
  
    // Verify digitally signed invoice
    verify_signed_invoice_primary: 404,
    verify_signed_invoice_secondary: 405,
    verify_signed_invoice_return: 406,
    verify_signed_invoice_vendor: 407,
    update_wallet_admin_settings: 408,
    update_freight_bill_admin_settings: 409,
  
    cancel_master_indent_import: 410,
  
    // 411- permisson for indent bulk upload
    indent_bulk_upload: 411,
  
    view_fixed_debit_settings: 412,
  
    update_legal_entity_settings: 413,
  
    view_rfq_freight_rate: 414, // to view frieght rate in RFQ QuoteAvailable
  
    view_dateroll: 600,
    create_dateroll: 601,
    update_dateroll: 602,
    remove_dateroll: 603,
  
    view_destination_charge: 604,
    import_destination_charge: 605,
    export_destination_charge: 606,
    view_source_charge: 607,
    import_source_charge: 608,
  
    view_approvals: 609,
  
    view_traffic_validation: 650,
    update_traffic_validation: 651,
  
    inbound_create_contract_indent: 705,
    inbound_create_direct_delivery_indent: 706,
    inbound_grn_bulk_upload: 707,
    inbound_indent_add_materials: 708,
    import_material_invoice_grn: 709,
    inbound_import_material_invoice_grn: 710,
    indent_upload_material: 711,
    view_value_discovery_3_dashboard: 712,
    view_value_discovery_4_dashboard: 713,
  
  
    /**
     * bill discount master permissions
     */
    view_billdiscount: 714,
    update_billdiscount: 715,
    import_billdiscount: 716,
    create_billdiscount: 717,
  
    view_vehicle_utilization_threshold: 718,
    update_vehicle_utilization_threshold: 719,
    export_vehicledetail: 720,
    import_vehicledetail: 721,
  
    view_cost_kg_month_wise_dashboard: 722,
    view_cost_kg_source_wise_dashboard: 723,
  
    // Bill to party admin permissions
    bill_to_gst_from_fcm_rcm: 724,
    view_bill_to_gst_from_fcm_rcm: 725,
    update_bill_to_gst_from_fcm_rcm: 726,
    view_freight_audit_process: 727,
    import_driver: 728,
  
    inbound_import_direct_dispatch: 729,
    indent_material_bulk_delete: 730,
    view_optima_move_to_pending: 731,
    create_only_rfq_indent: 732,
    driver_behaviour_report: 733,
    /**
     * MDM approval permissions
     */
    mdm_approval: 734, // view the page
    mdm_approval_accept_reject: 735, // to approve or reject
    // Commenting this permission since there is no approval page in MDM-V2
    // view_user_mdm_approval_request: 736, // to view only specific user upload
  
    // To controll LR Details
    update_profile_lorry_receipt: 737,
  
    // Movement level permissions
    mark_as_deliver_primary: 738,
    mark_as_deliver_secondary: 739,
    mark_as_deliver_vendor: 740,
    mark_as_deliver_return: 741,
  
    // exim-masters
    export_cha: 742,
    export_freightforwarder: 743,
    export_port: 744,
  
    view_route_master: 745,
    create_route_master: 746,
    update_route_master: 747,
  
    // Activity Time SLA Master permissions
    view_activity_time: 748,
    import_activity_time: 749,
    export_activity_time: 750,
    // Exception Page
    view_exception: 751,
    view_integration_log: 752,
    import_chargeable_weight: 753,
    // Order Hub
    view_order_hub: 754,
    // approval
    edit_freight_in_approval_pending: 755,
    view_master_custom_fields_admin_settings: 756,
    // report permission
    view_inbound_indent_status_report: 757,
    view_transporter_performance_report: 758,
    view_material_invoice_delivery_report: 759,
    view_secondary_epod_adherence: 760,
    view_material_invoice_freight_spent_report: 761,
    view_optima_variance_report: 762,
    view_shipment_unmapped_report: 763,
    view_optima_variance_summary_report: 764,
    view_optima_performance_secondary_report: 765,
    view_indent_with_material_invoice_status_report: 766,
    view_audit_log_report: 767,
    view_rate_matrix_history_report: 768,
    view_pay_audit_log_report: 769,
    view_bucc_bifurcation_report: 770,

    view_transportationdb: 1201,
    create_transportationdb: 1202,
    update_transportationdb: 1203,
    delete_transportationdb: 1204,
    import_transportationdb: 1205,
  
    view_track_dashboard: 1206,
    view_trips: 1207,
    view_map: 1208,
    view_rejections: 1209,
    update_invoice_fields_settings: 1210,
  
    import_material_user_association: 1211,
  
    // Freight zone master
    view_freight_zone: 1212,
    create_freight_zone: 1213,
    update_freight_zone: 1214,
    import_freight_zone: 1215,
    export_freight_zone: 1216,
  
    custom_clearance: 10001,
    si_submission: 10002,
    vessel_sailed: 10003,
    bol_issued: 10004,
    vessel_reached: 10005,
    handover_to_concor: 10006,
    containers_received: 10007,
    consignment_picked_from_origin: 10008,
    vessel_sailed_from_pol: 10009,
    containers_received_at_pod: 10010,
    handedover_to_concor: 10011, // Import level
    consignment_received: 10012,
    boe_filed: 10013,
    custom_clearance_done: 10014, // Import level
    examination_done: 10015,
    submit_duty_challan: 10016,
    vehicle_reached: 10017,
    custom_clearance_at_pod: 10018,
    delivered_to_consignee: 10019,
    shipment_received_at_airport: 10020,
    load_and_stow_cargo: 10021,
    handover_to_airlines: 10022,
    awb_issued: 10023,
    shipment_departure: 10024,
    flight_reached: 10025,
    pickup_complete: 10026,
    shipment_received_at_destination: 10027,
    shipment_departured_from_pol: 10028,
    shipment_received_at_pod: 10029,
    shipment_release_from_custom: 10030,
    custom_clearance__air_ff: 10031,
    boe_filed__air_ff: 10032,
    submit_duty_challan__air_ff: 10033,
    consginmene_received__air_ff: 10034,
    delivered_to_consignee__air_ff: 10035,
    shipment_received_at_airport_ff: 10036,
    linked_to_next_leg: 10037,
    custom_clearance__air: 10038,
    si_submission__air: 10039,
    custom_clearance_at_pod__air: 10040,
    delivered_to_consignee__air: 10041,
    consignment_picked_from_origin__air: 10042,
    consignment_received__air: 10043,
    boe_filed__air: 10044,
    examination_done__air: 10045,
    submit_duty_challan__air: 10046,
    delivery_order_details__air: 10047,
    shipment_departure__ff: 10048,
    awb_issued__ff: 10049,
    custom_clearance__air_cha: 10050,
    shipment_delivered_to_consignee: 10051,
    view_insurance_threshold: 10052,
    view_total_freight_cost_dashboard: 10053,
    view_variance_dashboard: 10054,
    view_overview_dashboard: 10055,
    view_indent_movement_dashboard: 10056,
    view_signify_operations_dashboard: 10057,
    view_signify_depot_dashboard: 10058,
    view_transit_penalty: 10059,
    view_rfq_historical_price: 10060,
    edit_wallet_in_accepted_status: 10061,
  
    create_package_master: 12000,
    view_package_master: 12001,
    update_package_master: 12002,
    import_package_master: 12003,
    export_package_master: 12004,
    delete_package_master: 12005,
    view_package_materials: 12006,
    import_material_package_map: 12007,
    export_material_package_map: 12008,
    view_perfetti_operation_dashboard: 10062,
    view_destination_dashboard: 10063,
    view_optima_docks: 10064,
    view_source_level_dashboard: 10065,
    view_fap_invoice_dashboard: 10066,
    service_level_performance_dashboard: 10067,
    trigger_zpod: 10068,
    enable_manual_end_trip_button: 10069,
    view_operations_overview_dashboard: 10070,
    material_throughput: 10071,
    update_lorry_receipt_admin_settings: 10072,
    create_transshipment: 10073,
    update_transshipment: 10074,
    view_transshipment: 10075,
    export_transshipment: 10076,
    import_transshipment: 10077,
    // Static discount admin permission
    view_static_discount: 10078,
  
    create_underutilized_indent: 10079,
    // Pay anomaly permissions
    view_pay_anomaly_settings: 10080,
    update_pay_anomaly_settings: 10081,
  
    lr_bulk_upload: 10082,
    inbound_lr_bulk_upload: 10083,
    optima_auto_indent: 10084,
    optima_export_cost_visibility: 10085,
    view_rfq_ceiling_price: 10086,
    import_materialcategory_additional: 10087,
    optima_indent_edit: 10088,
    optima_view_custom_params: 10089,
    update_grn: 10090,
    view_redirection: 10091,
    update_redirection: 10092,
    create_redirection: 10093,
    import_redirection: 10094,
    export_redirection: 10095,
    view_shipment_tracking_metrics_dashboard: 10096,
    view_indents_material_summary_dashboard: 10097,
    view_freight_spend_financials_dashboard: 10098,
    view_customer_fulfillment_dashboard: 10099,
    view_network_characterstics_dashboard: 10100,
    view_transporter_carrier_performance_dashboard: 10101,
    view_gate_pass_settings: 10102,
    view_freight_bill_posting_settings: 10103,
    view_indent_status_report: 10104,
    view_value_discovery_5_dashboard: 10105,
    view_value_discovery_6_dashboard: 10106,
    view_emissions_dashboard: 10107,
    view_discover_more_dashboard: 10108,
  
    // legal entity MDM
    view_legal_entity: 10109,
    import_legal_entity: 10110,
    create_legal_entity: 10111,
    export_legal_entity: 10112,
    update_legal_entity: 10113,
  
    view_contract_indent_base_freight: 10114,
    view_indent_status_operational_report: 10115,
  
    view_move_orders_to_pending_deliveries: 10116,
  
    edit_optima_vehicle_requirement_date: 10117,
    // return management
    create_return_deliveries: 10118,
    approve_return_requests: 10119,
    return_management_override_destination: 10120,
  
    // Payment Settlement
    view_payment_settlement: 10121,
  
    view_timeline_summary_report: 10122,
    hypertrack_report_download: 10123,
    view_quicksight_console: 10124,
  
    // Payment Settlement
    can_do_erp_return_created: 10125,
    can_do_erp_cn_issued: 10126,
    can_do_erp_invoice_settled: 10127,
    is_vehicle_status_editable: 10128,
    exclusive_draft_indent_creation: 10129,
  
    // Delete Future Contract
    delete_future_contract: 10130,
    
    // optima input permission
    update_handling_reconciliation: 10131,
    show_input_listing_export_btn: 10132,

    // PROCURE PERMISSIONS
    procure_pre_auction_lot_lane_view: 10133,
    procure_pre_auction_lot_lane_add_edit: 10134,
    procure_pre_auction_lot_lane_delete: 10135,
    procure_create_event: 10136,

    procure_events_view: 10137,
    procure_events_edit: 10138,
    procure_events_export: 10139,

    procure_vendor_master_view: 10140,
    procure_vendor_master_add_edit: 10141,
    procure_vendor_master_export: 10142,
    procure_vendor_master_mail_trigger: 10143,

    procure_thu_view: 10144,
    procure_thu_export: 10145,
    procure_thu_add_edit: 10146,

    procure_event_parameters_view: 10147,
    procure_event_parameters_export: 10148,
    procure_event_parameters_add_edit: 10149,

    procure_approval_master_view: 10150,
    procure_approval_master_add_edit: 10151,
    procure_approval_master_delete: 10152,

    procure_carrier_master_view: 10153,
    procure_carrier_master_add_edit: 10154,
    procure_carrier_master_delete: 10155,

    procure_currency_master_add_edit: 10156,
    procure_currency_master_delete: 10157,
    procure_currency_master_view: 10158,

    procure_emd_create: 10159,
    procure_emd_view: 10160,
    procure_emd_edit: 10161,

    procure_settings_view: 10162,
    procure_settings_modify: 10163,

    procure_event_templates_view: 10164,

    // Reasons Admin settings
    view_reason_settings: 10165,
    update_reason_settings: 10166,

    // Tracking sidebar
    view_tracking_menu: 10167,
    //Create and View Inbound indents
    create_return_indent: 10168,
    create_vendor_indent: 10169,
    view_return_indent: 10170,
    view_vendor_indent: 10171,
    optima_view_cs_page: 10172,
    update_consignee_coordinates: 10173,
    view_top_up_report: 10174,
    optima_manual_indent_creation: 10175,
    optima_view_all_depot_page: 10176,

    //create delivery from optima
    optima_create_delivery: 10177,
    optima_manual_indent_topup: 10178,
    delivery_report: 10179,
  
    hide_optima_optimize: 10180,

    import_vehicle_eta: 10181, // vehicle ETA import

    //edit page permissions
    optima_truck_type_and_transporter_view_only: 10182,
    optima_vehicle_requirement_date_view_only: 10183,

   //tare weight and gross weight
    set_truck_weights: 10184,
    edit_truck_weights: 10185,
    
    // hide rfq quote price , 
    hide_rfq_quotes_price: 10186,

    view_invoice_approval_settings: 10187,
    update_invoice_approval_settings: 10188,

    override_vahan_sarathi_validation: 10189,
    lr_attchment_rejection: 10190,
    hide_open_reindent: 10191,
    hide_rfq_reindent: 10192,
    hide_contract_reindent: 10193,
    optima_diagnostics: 10194,
    upload_material_after_dispatch: 10195,
    show_running_ideal_sob: 10196,
    stop_bfr: 10197,
    hide_indent_actions: 10198
  };
  
module.exports = {
    PermissionsList,
 };
